(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const currency = window.Shopify?.currency?.active || 'TND';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((cents || 0) / 100);
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) }, ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  };
  const checkoutAttributionKey = 'noNameOrderAttribution';
  const readStorage = (storage, key) => {
    try { return window[storage]?.getItem(key) || null; } catch { return null; }
  };
  const writeStorage = (storage, key, value) => {
    try { window[storage]?.setItem(key, value); } catch { /* Shopify preview can block storage. */ }
  };
  const removeStorage = (storage, key) => {
    try { window[storage]?.removeItem(key); } catch { /* Shopify preview can block storage. */ }
  };
  const orderAttemptId = (storageKey) => {
    const existing = readStorage('sessionStorage', storageKey);
    if (existing) return existing;
    const id = crypto.randomUUID?.() || `${Date.now()}_${crypto.getRandomValues(new Uint32Array(4)).join('_')}`;
    writeStorage('sessionStorage', storageKey, id);
    return id;
  };
  const captureCheckoutAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'campaign_id', 'ad_id', 'fbclid', 'gclid', 'ttclid'];
    let saved = {};
    try { saved = JSON.parse(readStorage('localStorage', checkoutAttributionKey) || '{}'); } catch { saved = {}; }
    keys.forEach((key) => {
      const value = String(params.get(key) || '').trim();
      if (value) saved[key] = value.slice(0, 180);
    });
    if (!saved.landing_page) saved.landing_page = `${window.location.pathname}${window.location.search}`.slice(0, 300);
    if (!saved.referrer && document.referrer) saved.referrer = document.referrer.slice(0, 300);
    saved.last_page = `${window.location.pathname}${window.location.search}`.slice(0, 300);
    writeStorage('localStorage', checkoutAttributionKey, JSON.stringify(saved));
    return saved;
  };
  captureCheckoutAttribution();

  const brandIntro = $('[data-brand-intro]');
  if (brandIntro) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sessionOnly = brandIntro.dataset.frequency !== 'always';
    const alreadySeen = sessionOnly && sessionStorage.getItem('noname-intro-seen');
    let introTimer;
    const finishBrandIntro = () => {
      if (sessionOnly) sessionStorage.setItem('noname-intro-seen', '1');
      document.body.classList.remove('st-intro-locked');
      brandIntro.classList.add('is-finished');
      window.setTimeout(() => brandIntro.remove(), 650);
      window.clearTimeout(introTimer);
    };
    if (reducedMotion || alreadySeen) {
      brandIntro.remove();
    } else {
      document.body.classList.add('st-intro-locked');
      introTimer = window.setTimeout(finishBrandIntro, Number(brandIntro.dataset.duration || 2800));
      $('[data-intro-skip]', brandIntro)?.addEventListener('click', finishBrandIntro);
    }
  }

  const menu = $('[data-menu]');
  $('[data-menu-toggle]')?.addEventListener('click', () => menu?.classList.toggle('is-open'));
  $('[data-language-unavailable]')?.addEventListener('click', (event) => {
    const notice = $('[data-language-notice]');
    if (!notice) return;
    notice.hidden = !notice.hidden;
    event.currentTarget.setAttribute('aria-expanded', String(!notice.hidden));
  });

  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const openCart = () => {
    cartOverlay.hidden = false;
    request(window.themeRoutes.cart).then(renderCart).catch(() => {});
    requestAnimationFrame(() => { cartOverlay.classList.add('is-open'); cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); });
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    cartOverlay?.classList.remove('is-open'); cartDrawer?.classList.remove('is-open'); cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { if (cartOverlay) cartOverlay.hidden = true; }, 350);
  };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  const changeLine = async (key, quantity) => {
    const cart = await request(window.themeRoutes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity }) });
    renderCart(cart);
  };
  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const body = $('[data-cart-body]'); const footer = $('[data-cart-footer]'); const reserve = $('[data-cart-reserve]');
    if (!body || !footer) return;
    body.innerHTML = '';
    if (!cart.items.length) {
      body.innerHTML = '<div class="st-cart-empty">Your bag is empty / سلّتك فارغة</div>';
      footer.hidden = true; if (reserve) reserve.hidden = true; return;
    }
    footer.hidden = false; if (reserve) reserve.hidden = false;
    const template = $('#CartItemTemplate');
    cart.items.forEach((item) => {
      const node = template.content.firstElementChild.cloneNode(true);
      $('[data-line-image]', node).src = item.image || '';
      $('[data-line-title]', node).textContent = item.product_title;
      $('[data-line-variant]', node).textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
      $('[data-line-quantity]', node).textContent = item.quantity;
      $('[data-line-price]', node).textContent = money(item.final_line_price);
      $('[data-line-minus]', node).addEventListener('click', () => changeLine(item.key, Math.max(0, item.quantity - 1)));
      $('[data-line-plus]', node).addEventListener('click', () => changeLine(item.key, item.quantity + 1));
      $('[data-line-remove]', node).addEventListener('click', () => changeLine(item.key, 0));
      body.append(node);
    });
    $('[data-cart-total]').textContent = money(cart.total_price);
  };
  request(window.themeRoutes.cart).then(renderCart).catch(() => {});

  $$('[data-card-swap]').forEach((button) => button.addEventListener('click', () => {
    const card = button.closest('[data-product-card]');
    const total = Math.max(1, Number(card.dataset.poseCount || 1));
    const current = Math.max(1, Number(card.dataset.poseIndex || 1));
    const next = current % total + 1;
    const following = next % total + 1;
    card.dataset.poseIndex = String(next);
    card.classList.toggle('is-pose-2', next === 2);
    card.classList.toggle('is-pose-3', next === 3);
    button.querySelector('span').textContent = `VIEW ${String(following).padStart(2, '0')}`;
    button.setAttribute('aria-label', `Show pose ${following}`);
  }));

  const wishes = new Set(JSON.parse(localStorage.getItem('st-wishlist') || '[]').map(String));
  $$('[data-wishlist-product]').forEach((button) => {
    const id = String(button.dataset.wishlistProduct);
    button.classList.toggle('is-active', wishes.has(id));
    button.addEventListener('click', () => { wishes.has(id) ? wishes.delete(id) : wishes.add(id); localStorage.setItem('st-wishlist', JSON.stringify([...wishes])); button.classList.toggle('is-active', wishes.has(id)); });
  });

  $$('[data-product-root]').forEach((root) => {
    const variants = JSON.parse($('[data-product-json]', root)?.textContent || '[]');
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', form);
    const addButton = $('[data-add-to-cart]', form);
    const selectedOptions = () => $$('[data-option-index]', form).map((fieldset) => $('.is-selected', fieldset)?.dataset.optionValue);
    const setVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((entry) => entry.options.every((value, index) => value === options[index]));
      if (!variant) { addButton.disabled = true; return; }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      $('[data-add-label]', addButton).textContent = variant.available ? 'زيد للسلة' : 'نفد الستوك';
      $('[data-add-price]', addButton).textContent = money(variant.price);
      $('[data-product-price]', root).innerHTML = money(variant.price) + (variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '');
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    $$('[data-option-value]', form).forEach((button) => button.addEventListener('click', () => {
      $$('[data-option-value]', button.closest('fieldset')).forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected'); setVariant();
    }));
    form?.addEventListener('submit', async (event) => {
      event.preventDefault(); const error = $('[data-form-error]', form); addButton.disabled = true;
      try { await request(window.themeRoutes.cartAdd, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) }); error.hidden = true; openCart(); }
      catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { addButton.disabled = false; }
    });

    const gallery = $('[data-gallery]', root); const track = $('[data-gallery-track]', gallery); const slides = $$('[data-media-index]', gallery); let index = 0; let startX = 0;
    const show = (next) => { if (!slides.length) return; index = (next + slides.length) % slides.length; track.style.transform = `translateX(${document.documentElement.dir === 'rtl' ? index * 100 : index * -100}%)`; slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index)); $$('[data-gallery-thumb]', gallery).forEach((thumb, i) => thumb.classList.toggle('is-active', i === index)); const current = $('[data-gallery-current]', gallery); if (current) current.textContent = String(index + 1).padStart(2, '0'); gallery.classList.add('is-interacting'); clearTimeout(gallery._timer); gallery._timer = setTimeout(() => gallery.classList.remove('is-interacting'), 1100); };
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => show(index - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => show(index + 1));
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    gallery?.addEventListener('pointerdown', (event) => { startX = event.clientX; gallery.classList.add('is-interacting'); });
    gallery?.addEventListener('pointerup', (event) => { const delta = event.clientX - startX; if (Math.abs(delta) > 35) show(index + (delta < 0 ? 1 : -1)); });
    gallery?.addEventListener('touchstart', () => gallery.classList.add('is-interacting'), { passive: true });
  });

  $$('[data-hero-3d]').forEach((hero) => {
    if (hero.classList.contains('no-3d')) return;
    hero.addEventListener('pointermove', (event) => { const box = hero.getBoundingClientRect(); hero.style.setProperty('--ry', `${((event.clientX - box.left) / box.width - .5) * 14}deg`); hero.style.setProperty('--rx', `${-((event.clientY - box.top) / box.height - .5) * 8}deg`); });
    hero.addEventListener('pointerleave', () => { hero.style.setProperty('--ry', '0deg'); hero.style.setProperty('--rx', '0deg'); });
  });

  const checkoutForm = $('[data-cod-checkout-form]');
  checkoutForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const error = $('[data-checkout-error]');
    const submit = $('button[type="submit"]', checkoutForm);
    const form = new FormData(checkoutForm);
    const phone = String(form.get('phone') || '').replace(/\D/g, '');
    const configuredEndpoint = String(checkoutForm.dataset.orderEndpoint || '').trim().replace(/\/+$/, '');
    const endpoint = configuredEndpoint.endsWith('/order') ? configuredEndpoint : `${configuredEndpoint}/order`;
    if (!checkoutForm.reportValidity()) return;
    if (!/^\d{8}$/.test(phone)) {
      error.textContent = 'رقم الهاتف لازم يكون 8 أرقام بعد +216.'; error.hidden = false; return;
    }
    if (!configuredEndpoint || !configuredEndpoint.startsWith('https://')) {
      error.textContent = 'Cloudflare order endpoint is not connected yet. اربط الحساب الجديد من Theme settings.'; error.hidden = false; return;
    }
    submit.disabled = true; error.hidden = true;
    try {
      const cart = await request(window.themeRoutes.cart);
      if (!cart.items.length) throw new Error('سلّتك فارغة.');
      const attemptStorageKey = `noNameOrderAttempt:${cart.token || 'cart'}`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          idempotencyKey: orderAttemptId(attemptStorageKey),
          customerName: String(form.get('name') || ''),
          email: String(form.get('email') || ''),
          phoneLocal: phone,
          state: String(form.get('governorate') || ''),
          city: String(form.get('city') || ''),
          address: String(form.get('address') || ''),
          note: String(form.get('note') || ''),
          website: String(form.get('website') || ''),
          attribution: (() => { try { return JSON.parse(readStorage('localStorage', checkoutAttributionKey) || '{}'); } catch { return {}; } })(),
          cartToken: cart.token,
          items: cart.items.map((item) => ({
            variantId: item.variant_id,
            productTitle: item.product_title,
            variantTitle: item.variant_title,
            quantity: item.quantity
          }))
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) throw new Error(data.error || 'تعذّر تأكيد الطلبية. عاود جرّب.');
      removeStorage('sessionStorage', attemptStorageKey);
      await request(window.themeRoutes.cartClear, { method: 'POST', body: '{}' });
      checkoutForm.hidden = true;
      $('[data-checkout-success]').hidden = false;
      const orderNumber = $('[data-checkout-order-number]');
      if (orderNumber) orderNumber.textContent = data.orderName || data.draftOrderName || '—';
      $$('[data-cart-count]').forEach((el) => { el.textContent = '0'; });
    } catch (err) {
      error.textContent = err.message; error.hidden = false;
    } finally { submit.disabled = false; }
  });
})();
